import { isSocialPlatform, Platform } from '@/types/api/platforms';

export const PercentageByPlatformTooltipContent = ({
  label,
  value,
  selectedPlatform,
}: {
  label: string;
  value: number;
  selectedPlatform: Platform;
}) => {
  return (
    <div>
      <p className="mb-2 text-sm font-medium ">{label}</p>
      <p className="text-md font-medium text-[#4040A8]">{value}%</p>
      <p className="flex flex-col text-sm">
        <span className="text-textMedGrey ">
          {selectedPlatform.toLowerCase() === 'all combined'
            ? 'of people viewing your content on YouTube, Instagram, and TikTok'
            : isSocialPlatform(selectedPlatform)
              ? 'of people viewing your content on'
              : 'of people listening to your audio podcast distributed by'}
        </span>
        <span className="font-medium">
          {selectedPlatform.toLowerCase() === 'all combined'
            ? 'all podcast players, YouTube, Instagram, TikTok'
            : selectedPlatform}
        </span>
      </p>
      {selectedPlatform === Platform.Acast && (
        <p className="text-sm text-textMedGrey mt-2">
          This includes listens on all podcast players such as Spotify, Apple Podcast, Castbox,
          Pocket Casts, etc.
        </p>
      )}
    </div>
  );
};
